(function ($, Drupal) {
  Drupal.behaviors.nvs_video_theme = {
    attach: function (context, settings) {
      /* bootstrap carousel */
      $(document).ready(function () {
        $(".carousel-video").carousel({
          interval: false,
        });
        $(".carousel-thubnails").carousel({
          interval: false,
        });
      });

      // handles the carousel thumbnails
      // https://stackoverflow.com/questions/25752187/bootstrap-carousel-with-thumbnails-multiple-carousel
      // jQuery 4: .click(fn) → .on('click', fn)
      $("[id^=carousel-selector-]").on("click", function () {
        var id_selector = $(this).attr("id");
        var id = parseInt(id_selector.substr(id_selector.lastIndexOf("-") + 1));
        $(".carousel-video").carousel(id);
      });

      let video_thumb_count = $(".thumb").length;
      // when the carousel slides, auto update
      $(".carousel-video").on("slide.bs.carousel", function (e) {
        var id = parseInt($(e.relatedTarget).attr("data-slide-number"));
        $("[id^=carousel-selector-]").removeClass("selected");
        $("[id=carousel-selector-" + id + "]").addClass("selected");
      });

      $(".carousel-indicators li").on(function (e) {
        $("[id^=carousel-selector-]").removeClass("active");
        $("[id=carousel-selector-" + id + "]").addClass("active");
      });

      $(".carousel-video .carousel-item img").on("click", function (e) {
        var src = $(e.target).attr("data-remote");
        if (src) {
          $(this).ekkoLightbox();
        }
      });
    },
  };
})(jQuery, Drupal);
